module.exports = __webpack_public_path__ + "static/paulette_0-812044acddc64045d206eea16bd9f599.jpg";